import React from "react";
import API from "../../Services/API";
import { toast } from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import { useNavigate } from "react-router-dom";
import Header from "../../Layouts/Header";
import Navbar from "../../Layouts/Navbar";
import { AiOutlineAppstoreAdd } from "react-icons/ai";
import moment from "moment-jalaali";


const PROCESS_FOR = "Sales";

const STATUS = {
    0: { title: "در انتظار بررسی", cls: "text-bg-warning" },
    1: { title: "تایید شده", cls: "text-bg-success" },
    2: { title: "رد شده", cls: "text-bg-danger" },
};

function ReturnRequestList() {
    const navigate = useNavigate();
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [items, setItems] = React.useState([]);
    const [page, setPage] = React.useState(1);
    const [lastPage, setLastPage] = React.useState(1);
    const [openId, setOpenId] = React.useState(null);

    React.useEffect(() => {
        setIsLoaded(false);
        API.getReturnRequests({ page, processFor: PROCESS_FOR })
            .then((response) => {
                setItems(response.data.items);
                setLastPage(response.data.last_page);
                setIsLoaded(true);
            })
            .catch((error) => {
                toast.error(error.response ? error.response.data.message : error.message);
                setIsLoaded(true);
            });
    }, [page]);

    return (
        <React.Fragment>
            <Header />
            <Navbar page="upsorders" public={1} />
            <Toast />
            {!isLoaded && <Loading />}
            <main id="main" className="main rtl">
                <div className="pagetitle mb-5 border-bottom pb-4 d-flex justify-content-between align-items-center">
                    <h1>
                        <AiOutlineAppstoreAdd className="ms-2" />
                        درخواست‌های مرجوعی
                    </h1>
                    <button className="btn btn-primary text-small-2" onClick={() => navigate("/return-request")}>
                        ثبت مرجوعی جدید
                    </button>
                </div>

                <section className="section">
                    <div className="card">
                        <div className="card-body pt-3">
                            <div className="table-responsive">
                                <table className="table table-striped text-small-2">
                                    <thead className="text-center">
                                    <tr>
                                        <th>#</th>
                                        <th>تاریخ</th>
                                        <th>نماینده</th>
                                        <th>شماره فاکتور</th>
                                        <th>تعداد</th>
                                        <th>علت خرابی</th>
                                        <th>وضعیت</th>
                                        <th></th>
                                    </tr>
                                    </thead>
                                    <tbody className="text-center">
                                    {items.length === 0 && isLoaded && (
                                        <tr><td colSpan="8" className="text-muted py-4">درخواستی ثبت نشده است.</td></tr>
                                    )}
                                    {items.map((r, index) => (
                                        <React.Fragment key={r.id}>
                                            <tr>
                                                <th scope="row">{index + 1}</th>
                                                <td>{r.created_at && moment(r.created_at).format("jYYYY/jMM/jDD")}</td>
                                                <td>{r.vendor_title}</td>
                                                <td>{r.factor_number}</td>
                                                <td>{r.battery_qty}</td>
                                                <td className="text-truncate" style={{ maxWidth: 180 }}>{r.failure_reason}</td>
                                                <td>
                            <span className={`badge ${STATUS[r.status]?.cls || "text-bg-secondary"}`}>
                              {STATUS[r.status]?.title || "-"}
                            </span>
                                                </td>
                                                <td>
                                                    <button
                                                        className="btn btn-sm btn-outline-secondary text-small-2"
                                                        onClick={() => setOpenId(openId === r.id ? null : r.id)}
                                                    >
                                                        {openId === r.id ? "بستن" : "جزئیات"}
                                                    </button>
                                                </td>
                                            </tr>
                                            {openId === r.id && (
                                                <tr>
                                                    <td colSpan="8" className="text-end bg-light">
                                                        <div className="p-2 text-small-2">
                                                            <div className="mb-2"><strong>علت خرابی: </strong>{r.failure_reason}</div>
                                                            <div className="mb-2"><strong>ولتاژ: </strong>{r.voltage}</div>
                                                            <div className="mb-2"><strong>نوع خدمات: </strong>{r.service_type}</div>
                                                            {r.other_description && (
                                                                <div className="mb-2"><strong>سایر توضیحات: </strong>{r.other_description}</div>
                                                            )}
                                                            <table className="table table-sm text-small-3 mt-3">
                                                                <thead className="text-center">
                                                                <tr><th>برند</th><th>آمپراژ</th><th>نوع</th><th>تعداد</th></tr>
                                                                </thead>
                                                                <tbody className="text-center">
                                                                {(r.batteries || []).map((b, i) => (
                                                                    <tr key={i}>
                                                                        <td>{b.brand}</td><td>{b.amperage}</td>
                                                                        <td>{b.batteryType}</td><td>{b.count}</td>
                                                                    </tr>
                                                                ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    ))}
                                    </tbody>
                                </table>
                            </div>

                            {lastPage > 1 && (
                                <div className="d-flex justify-content-center gap-2 mt-3">
                                    <button className="btn btn-outline-secondary btn-sm" disabled={page <= 1} onClick={() => setPage(page - 1)}>قبلی</button>
                                    <span className="align-self-center text-small-2">{page} / {lastPage}</span>
                                    <button className="btn btn-outline-secondary btn-sm" disabled={page >= lastPage} onClick={() => setPage(page + 1)}>بعدی</button>
                                </div>
                            )}
                        </div>
                    </div>
                </section>
            </main>
        </React.Fragment>
    );
}

export default ReturnRequestList;